<template>
  <div id="app">
    <div id="common_upload_img" style="display:none;width:0;height:0;"></div>
    <div id="common_upload_file" style="display:none;width:0;height:0;"></div>
    <div id="common_upload_file_k3" style="display:none;width:0;height:0;"></div>
    <div id="common_copy_btn" style="display:none;width:0;height:0;"></div>
    <transition name="router-fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import $ from 'jquery'
import Clipboard from 'clipboard'
import config from '@/components/common/config'
import {
  Loading
} from 'element-ui'

window.Mc || (window.Mc = {})

// 是否能上传
window.Mc._canUpload = true

// 显示图片上传
window.Mc.showImgUpload = (callback) => {
  if (window.Mc._canUpload) {
    $('#common_upload_img input').trigger('click')
    callback && callback()
  }
}

// 显示文件上传
window.Mc.showFileUpload = (callback) => {
  if (window.Mc._canUpload) {
    $('#common_upload_file input').trigger('click')
    callback && callback()
  }
}

// 显示文件上传 - k3询价excel上传
window.Mc.showFileUploadK3 = (callback) => {
  if (window.Mc._canUpload) {
    $('#common_upload_file_k3 input').trigger('click')
    callback && callback()
  }
}

// 复制文本
var copyTxt
window.Mc.copyTxt = (txt, callback) => {
  copyTxt = txt
  $('#common_copy_btn').trigger('click')
  callback && callback()
}

let loadingInstance

export default {
  name: 'app',
  mounted() {
    // 初始化全局图片上传
    this.initImgUpload()
    // 初始化全局文件上传
    this.initFileUpload()
    // 初始化全局文件上传 - k3询价excel上传
    this.initFileUploadK3()
    // 初始化全局复制
    this.initClipboard()
  },
  methods: {
    // 初始化全局图片上传
    initImgUpload() {
      // 全局图片上传
      window.Mc.gImageUpload = new window.Mc.Uploader({
        target: '#common_upload_img',
        url: config.AjaxUrl + '/controller.ashx?action=uploadimage',
        auto: true,
        showLoadingFun() {
          window.Mc._canUpload = false
          loadingInstance = Loading.service({
            fullscreen: true
          })
        },
        hideLoadingFun() {
          window.Mc._canUpload = true
          loadingInstance.close()
        },
        successHideLoading: false,
        success: function($this, res, file) {
          window.vueEvent.$emit('upload:success', res.data)
        }
      })
    },
    // 初始化全局文件上传
    initFileUpload() {
      // 全局文件上传
      window.Mc.gFileUpload = new window.Mc.Uploader({
        target: '#common_upload_file',
        type: 'file',
        name: 'upfile',
        url: config.AjaxUrl + '/controller.ashx?action=uploadfile',
        auto: true,
        showLoadingFun() {
          window.Mc._canUpload = false
          loadingInstance = Loading.service({
            fullscreen: true
          })
        },
        hideLoadingFun() {
          window.Mc._canUpload = true
          loadingInstance.close()
        },
        successHideLoading: false,
        success: function($this, res, file) {
          window.vueEvent.$emit('upload:success', res.data)
        }
      })
    },
    // 初始化全局文件上传 - k3询价excel上传
    initFileUploadK3() {
      // 全局文件上传
      window.Mc.gFileUploadK3 = new window.Mc.Uploader({
        target: '#common_upload_file_k3',
        type: 'file',
        name: 'file',
        url: config.AjaxUrl + '/Ajax/UploadExcelTemplateInAdmin',
        auto: true,
        showLoadingFun() {
          window.Mc._canUpload = false
          loadingInstance = Loading.service({
            fullscreen: true
          })
        },
        hideLoadingFun() {
          window.Mc._canUpload = true
          loadingInstance.close()
        },
        successHideLoading: false,
        success: function($this, res, file) {
          window.vueEvent.$emit('upload:success', res)
        }
      })
    },
    // 初始化全局复制
    initClipboard() {
      let _this = this
      // 如果存在则销毁
      if (window.Mc.gClipboard) {
        window.Mc.gClipboard.destroy()
      }
      // 全局复制
      let clipboard = new Clipboard('#common_copy_btn', {
        text() {
          return copyTxt
        }
      })
      clipboard.on('success', function(e) {
        _this.$message.success('copy success!')
        // console.info('Action:', e.action)
        // console.info('Text:', e.text)
        // console.info('Trigger:', e.trigger)
        // e.clearSelection()
      })
      clipboard.on('error', function(e) {
        _this.$message.error('copy fail!')
        // console.error('Action:', e.action)
        // console.error('Trigger:', e.trigger)
      })
      window.Mc.gClipboard = clipboard
    }
  }
}
</script>

<style lang="scss">
@import '~@/style/framework';
@import '~@/style/common';
</style>


// WEBPACK FOOTER //
// App.vue?572eaca6